import React from 'react'
import { Link } from 'gatsby'
import Centered from 'shared/ui/Centered'
import team from '../../data/team'
import './BlogIndexHero.scss'

function BlogIndexHero({ post }) {
  const { name } = team.find((t) => t.id === post.author)

  return (
    <section className="blog-index-hero" aria-label="Featured Post">
      <Centered as="article">
        <div className="slant">
          <div className="featured" aria-hidden>
            Featured Post
          </div>
          <br />
          <h1 className="blog-title">{post.title}</h1>
          <div className="blog-author">By {name}</div>
        </div>
        <Link
          to={`/blog/${post.slug}`}
          className="blog-cta button"
          aria-label={`Read the post: ${post.title}`}
        >
          Read Post
        </Link>
      </Centered>
    </section>
  )
}

export default BlogIndexHero
